import { EpicRefined } from 'interfaces/middleware'
import { mergeMap, map, take } from 'rxjs/operators'
import { of, merge, race } from 'rxjs'
import {
  AdvisorMeetingActions,
  SubscribeAndCreateMeetingAction,
  createAdvisorMeetingActionCreator,
} from 'components/features/coaching/advisorStore/actions/advisorMeetingActions'
import { filterRequest, filterRequestOfType } from 'rxOperators/filterRequestOfType'
import { CREATE_STRIPE_PAYMENT_METHOD, createStripePaymentMethodActionCreator, StripeAction } from 'actions/stripeActions'
import { isMemberPremiumSelector } from 'selectors/globalSelectors'
import FloatingPaneAction, { modifyFloatingPaneActionCreator } from 'actions/floatingPanesActions'

export const subscribeAndCreateMeetingEpic: EpicRefined<AdvisorMeetingActions | FloatingPaneAction | StripeAction> = (action$, store) => action$.pipe(
  filterRequest(SubscribeAndCreateMeetingAction.type),
  mergeMap((action) => {
    const { params } = action.payload

    const success$ = action$.pipe(
      filterRequestOfType(CREATE_STRIPE_PAYMENT_METHOD, 'success'),
      take(1),
      mergeMap(() => {
        const state = store.getState()
        const isSubscribed = isMemberPremiumSelector(state)
        if (!isSubscribed) {
          return of(action.fail({ errorCode: 0 }))
        }

        return merge(
          of(modifyFloatingPaneActionCreator('advisor', { mode: 'request', step: 'booking' })),
          of(createAdvisorMeetingActionCreator.request(params.fields)),
          of(action.success()),
        )
      }),
    )

    const fail$ = action$.pipe(
      filterRequestOfType(CREATE_STRIPE_PAYMENT_METHOD, 'fail'),
      take(1),
      map(({ payload }) => action.fail({ errorCode: payload.errorCode, errorExtra: payload.errorExtra, errorsMap: payload.errorsMap })),
    )

    return merge(
      race(
        success$,
        fail$,
      ),
      of(createStripePaymentMethodActionCreator.request({ amount: params.amount }))
    )
  }),
)

